<script>
	import Loading from "@/components/layout/Loading.vue";
	import SinResultados from "@/components/layout/SinResultados.vue";

	export default {
		components: {
			Loading,
			SinResultados
		},
		props: {
			data: {
				type: Array,
				required: true
			},
			loading: {
				type: Boolean,
				required: true
			},
		},
		methods: {
			checkLeido(vistos) {
				return Object.values(vistos).some (
					(visto) => visto.usuario[0].id_usuario == this.$ls.get("user").id_usuario
				);
			},
			toMonthNameShort(date) {
				const newDate = new Date(date);
				newDate.setDate(newDate.getDate() + 1);
				return newDate
					.toLocaleString("es-CL", { month: "short" })
					.replace(/\./, "");
			},
			toDayNumber(date) {
				const newDate = new Date(date);
				newDate.setDate(newDate.getDate() + 1);
				return newDate.toLocaleString("es-CL", { day: "numeric" });
			}
		},
	}
</script>
<template>
	<section id="videos-list">

		<Loading 
			v-if="loading"
			pixeles="200px"
		/>

		<SinResultados v-if="!loading && data.length === 0"/>

		<template v-if="!loading">		
			<div class="row">
				<div 
					v-for="item in data"
					:key="item.id_video"
					class="col-12 col-lg-6 col-xl-4 col-xxl-3 mb-3">
					<div class="card border-0 card-list">
						<div class="card-body p-2">
							<router-link 
								:to="`/videos/${item.id_video}`"
								class="card-list-link"
							>
								<figure class="position-relative">
									<span class="card-list-date">
										{{ toDayNumber(item.fecha_video) }}
										<small>
											{{ toMonthNameShort(item.fecha_video) }}
										</small>
									</span>
									<div class="card-list-video">
										<div class="card-list-video-play">
										<font-awesome-icon icon="fa-solid fa-play" class="card-list-video-play-icon"></font-awesome-icon>
										</div>
									</div>
									<img 
										:src="item.url_imagen"
										class="card-list-img"
									>
								</figure>
								<div class="p-2">
									<h5 class="card-title h5-custom card-list-title font-main text-secondary">
										{{ item.titulo_video }}
									</h5>
									<div class="d-flex align-items-center justify-content-between">
										<h5 
											v-if="checkLeido(item.vistos)"
											class="mb-0 h5-custom"
										>
										<span class="badge text-secondary border rounded-4">
											Visto
										</span>
										</h5>
										<h5 class="mb-0 h5-custom" v-else>
											<span class="badge text-white rounded-4 bg-main">
												Sin ver
											</span>
										</h5>
										<div class="ms-3"> 
											<a 
												href="javascript:"
												class="card-custom-footer-like color-main"
											>
												<font-awesome-icon icon="fa-solid fa-comment"></font-awesome-icon>
											</a>
											<span class="card-custom-footer-like-count ms-1">
												{{ item.comentarios.length }}
											</span>
											<a 
												href="javascript:"
												class="card-custom-footer-like ms-2 color-main"
											>
												<span 
												v-if="item.likes.length === 0" 
												key="solid-heart"
												>
												<font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
												</span>
												<span 
												v-if="item.likes.length > 0" 
												key="regular-heart"
												>
												<font-awesome-icon icon="fa-solid fa-heart" :class="item.confirm_like !== null&&'color-red'"></font-awesome-icon>
												</span>
											</a>
											<span class="card-custom-footer-like-count ms-1">
												{{  item.likes.length }}
											</span>
										</div>
									</div>
								</div>	
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</template>
	</section>
</template>